export default __webpack_public_path__ + "static/media/grupo.5126e499.png";